<div id="wrapper">
  <div id="filters">
    <div class="row">
      <div class="col-md-2 name">{{ 'label.Year' | translate }}</div>
      <div class="col-md-2">
        <select [(ngModel)]="year" (change)="onChange()">
          <option *ngFor="let item of yearFilterOptions" [value]="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 name">{{ 'label.Month' | translate }}</div>
      <div class="col-md-2">
        <select [(ngModel)]="month" (change)="onChange()">
          <option *ngFor="let item of monthFilterOptions" [value]="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 name">{{ 'label.Portfolio' | translate }}</div>
      <div class="col-md-2">
        <select [(ngModel)]="portfolioId" (change)="onChange()">
          <option selected></option>
          <option *ngFor="let item of portfolios" [value]="item.portfolioId">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div *ngIf="plan">
    <div style="margin-bottom: 3em">
      <div class="row">
        <div class="col-md-2 name">{{ 'label.Month' | translate }}</div>
        <div class="col-md-2">
          {{ 'label.' + monthNames[plan.month - 1] | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 name">
          {{ 'label.NumberOfWorkdaysShort' | translate }}:
        </div>
        <div class="col-md-2">{{ plan.workingDays }}</div>
      </div>
      <div class="row">
        <div class="col-md-2 name">
          {{ 'label.NumberOfTotalDaysShort' | translate }}:
        </div>
        <div class="col-md-2">{{ plan.totalDays }}</div>
      </div>
      <div class="row">
        <div class="col-md-2 name">
          {{ 'label.NumberOfHolidaysShort' | translate }}:
        </div>
        <div class="col-md-2">{{ plan.holidays }}</div>
      </div>
      <div class="row">
        <div class="col-md-2 name">{{ 'label.Saturday' | translate }}:</div>
        <div class="col-md-2">{{ plan.saturdays }}</div>
      </div>
    </div>

    <div
      *ngFor="let type of plan.monthlyPlanProductTypes; let i = index"
      class="type-section"
      [ngClass]="{
        share:
          type.productType.productTypeId ==
            ProductTypeEnum.Announcement_FacebookShare ||
          type.productType.productTypeId ==
            ProductTypeEnum.Announcement_LinkedInShare ||
          type.productType.productTypeId ==
            ProductTypeEnum.Announcement_InstagramShare ||
          type.productType.productTypeId ==
            ProductTypeEnum.Announcement_Vk_share
      }"
    >
      <div
        *ngIf="
          typeItemsMap[
            type.productType.productTypeId +
              (type.website ? '_' + type.website.providerWebsiteId : '')
          ].length != 1
        "
        class="row"
      >
        <div class="col-md-2 name">
          {{
            type.productType.name +
              (type.website ? ' (' + type.website.name + ')' : '')
          }}
        </div>
        <div class="col-md-2">
          <input [(ngModel)]="type.totalCount" type="number" min="0" />
        </div>
      </div>

      <div
        *ngIf="
          type.productType.productTypeId == ProductTypeEnum.Announcment &&
          type.website
        "
        class="row"
        style="margin-top: -10px"
      >
        <div class="col-md-2 name dark">{{ 'label.Sold' | translate }}</div>
        <div class="col-md-2">
          <input
            [(ngModel)]="type.soldCount"
            type="number"
            min="0"
            class="dark"
          />
        </div>
      </div>

      <div
        *ngFor="
          let item of typeItemsMap[
            type.productType.productTypeId +
              (type.website ? '_' + type.website.providerWebsiteId : '')
          ]
        "
        class="row"
      >
        <div class="col-md-2 name">
          {{
            item.productCode +
              (type.website &&
              typeItemsMap[
                type.productType.productTypeId +
                  (type.website ? '_' + type.website.providerWebsiteId : '')
              ].length == 1
                ? ' (' + type.website.name + ')'
                : '')
          }}
        </div>
        <div class="col-md-2">
          <input [(ngModel)]="item.count" type="number" min="0" />
        </div>
      </div>

      <div *ngIf="i == 0" class="row">
        <div class="col-md-2 name dark">{{ 'label.Share' | translate }}</div>
        <div class="col-md-2">
          <input
            [(ngModel)]="plan.sharesPlan"
            type="number"
            min="0"
            class="dark"
          />
        </div>
      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-md-2 name dark">{{ 'label.Payments' | translate }}</div>
      <div class="col-md-2">
        <input [(ngModel)]="plan.payments" type="number" min="0" class="dark" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-2 name dark">{{ 'label.Invoices' | translate }}</div>
      <div class="col-md-2">
        <input [(ngModel)]="plan.invoices" type="number" min="0" class="dark" />
      </div>
    </div>

    <br />

    <button [disabled]="!plan.isEditable" type="button" (click)="onSave()">
      {{ 'label.Save' | translate }}
    </button>
    <button *ngIf="isInCreateMode" type="button" (click)="onCancel()">
      {{ 'label.Cancel' | translate }}
    </button>
  </div>
</div>
